<template>
  <div class="container">
    <div class="header">
      <t-breadcrumb style="margin-right: 20px">
        <t-breadcrumb-item :to="{ name: 'ApplicationList' }">应用列表</t-breadcrumb-item>
        <t-breadcrumb-item>用户管理</t-breadcrumb-item>
      </t-breadcrumb>
    </div>
    <div class="content">
      <div class="top">
        <div>
          <t-button @click="handleOpenAdd">新增用户</t-button>
        </div>
        <div>
          <t-form :data="formData" layout="inline" ref="form">
            <t-form-item label="应用名称" name="appId">
              <t-select v-model="formData.appId" @change="onAppChange">
                <t-option v-for="item in appList" :key="item.value" :label="item.label" :value="item.value"></t-option>
              </t-select>
            </t-form-item>
            <t-form-item label="用户名称/手机号" name="keyword">
              <t-input v-model="formData.keyword" @change="onKeywordChange"></t-input>
            </t-form-item>
          </t-form>
        </div>
      </div>
      <div class="data-table">
        <t-table
          :data="tableData"
          :columns="columns"
          rowKey="id"
          :loading="loadingData"
          :pagination="pagination"
          @page-change="onPageChange"
          stripe
        >
          <template #oper="slotProps">
            <t-button theme="primary" variant="text" @click="handleOpenEdit(slotProps)">编辑</t-button>
            <t-button theme="primary" variant="text" @click="handleOpenDel(slotProps)">删除</t-button>
          </template>
        </t-table>
      </div>
    </div>

    <t-loading attach=".content" v-if="initLoading"></t-loading>

    <t-dialog
      :header="deleteTitle"
      theme="warning"
      :visible.sync="dialogDelVisible"
      :confirmBtn="{ content: '确定', loading: loadingDelete }"
      @confirm="onConfirmDel"
    >
      <div slot="body">请确认是否删除该用户，确定后将从{{ selectedUser.applicationName }}删除该用户</div>
    </t-dialog>

    <UserAdd
      v-if="dialogAddVisible"
      :dialog-visible.sync="dialogAddVisible"
      :app-list="appList"
      @onRefresh="refresh"
    ></UserAdd>

    <UserEdit
      v-if="dialogEditVisible"
      :dialog-visible.sync="dialogEditVisible"
      :app-list="appList"
      :user-info="selectedUser"
      @onRefresh="refresh"
    ></UserEdit>
  </div>
</template>

<script>
import { getApplicationList } from '@/api/application/list';
import { getAppUserList, deleteAppUser } from '@/api/application/app';
import UserAdd from './user-add.vue';
import UserEdit from './user-edit.vue';

export default {
  name: 'application-user-manage-list',
  components: {
    UserAdd,
    UserEdit,
  },
  data() {
    return {
      formData: {
        appId: '',
        keyword: '',
      },

      initLoading: false,
      loadingDelete: false,

      appList: [],

      loadingData: false,

      tableData: [
        // { appName: '应用一', appId: 111, userName: '张三', phone: '15818515514', role: 1 },
        // { appName: '应用一', appId: 222, userName: '张三', phone: '15818515514', role: 2 },
      ],
      pagination: {
        total: 0,
        current: 1,
        pageSize: 10,
      },
      columns: [
        {
          colKey: 'entityName',
          title: '用户名称',
        },
        {
          colKey: 'phoneNumber',
          title: '用户手机号',
        },
        {
          colKey: 'roleType',
          title: '用户角色',
          render(h, { row: { roleType } }) {
            return roleType === 'admin' ? '管理员' : '用户';
          },
        },
        {
          width: 250,
          colKey: 'oper',
          title: '操作',
        },
      ],

      selectedUser: {},

      dialogAddVisible: false,
      dialogEditVisible: false,
      dialogDelVisible: false,
    };
  },
  computed: {
    deleteTitle() {
      return `是否确定从“${this.selectedUser.applicationName}”中删除该用户？`;
    },
  },
  watch: {
    $route() {
      // console.log('watch $route change');
      this.reset();
      this.refresh();
    },
  },
  created() {
    this.formData.appId = Number(this.$route.params.analysisAppId);
  },
  async mounted() {
    try {
      this.initLoading = true;
      await this.getApplicationList();
      await this.getList();
    } finally {
      this.initLoading = false;
    }
  },
  methods: {
    onPageChange(pageInfo) {
      const { current, pageSize } = pageInfo;
      this.pagination.current = current;
      this.pagination.pageSize = pageSize;
      this.getList();
    },
    reset() {
      this.pagination.current = 1;
      this.formData.appId = Number(this.$route.params.analysisAppId);
    },
    refresh() {
      this.getList();
    },
    async getList() {
      try {
        this.loadingData = true;
        const res = await getAppUserList({
          params: {
            pageNo: this.pagination.current,
            pageSize: this.pagination.pageSize,
            appId: this.formData.appId,
            keyword: this.formData.keyword,
          },
        });

        this.pagination.total = res.total;
        this.tableData = res.list;
      } finally {
        this.loadingData = false;
      }
    },

    async getApplicationList() {
      const res = await getApplicationList({
        params: {
          pageNo: 1,
          pageSize: 1000,
        },
      });
      this.appList = res.list.filter(i => i.roleType === 'admin').map(i => ({ label: i.applicationName, value: i.id }));
    },

    handleOpenAdd() {
      this.dialogAddVisible = true;
    },
    handleOpenEdit({ row }) {
      this.selectedUser = row;
      this.dialogEditVisible = true;
    },
    handleOpenDel({ row }) {
      this.selectedUser = row;
      this.dialogDelVisible = true;
    },
    async onConfirmDel() {
      try {
        this.loadingDelete = true;
        await deleteAppUser(this.selectedUser.id);
        this.$message.success('删除成功');
        this.dialogDelVisible = false;
        this.refresh();
      } finally {
        this.loadingDelete = false;
      }
    },

    onAppChange(appId) {
      this.$router.push({
        name: 'ApplicationUserManage',
        params: {
          analysisAppId: appId,
        },
      });
    },

    onKeywordChange() {
      this.pagination.current = 1;
      this.refresh();
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  .content {
    background-color: white;
    margin-top: 20px;
    padding: 20px;

    .top {
      display: flex;
      justify-content: space-between;
    }

    .data-table {
      margin-top: 20px;
    }
  }
}
</style>
